import { CustomColumn } from '../../../types/customColumn';
import { InventoryMovementDTO } from '../../../types/inventory/InventoryMovementTypes';
import { formatCurrency } from '../../../utils/formatCurrency';

/**
 * Columnas para mostrar los movimientos de inventario
 */
export const inventoryMovementColumns: CustomColumn<InventoryMovementDTO>[] = [
  /**
   * 📦 Producto
   */
  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => (
      <div className="min-w-[240px] max-w-[320px]">
        <div className="font-medium text-black dark:text-white">
          {row.original.productName || '—'}
        </div>
      </div>
    ),
  },

  /**
   * 🏢 Sucursal
   */
  {
    Header: 'Sucursal',
    accessor: 'branchName',
    customCell: ({ row }) => (
      <div className="min-w-[180px]">
        <span className="text-gray-700 dark:text-gray-300 text-sm">
          {row.original.branchName || '—'}
        </span>
      </div>
    ),
  },

  /**
   * 🔄 Tipo de movimiento
   */
  {
    Header: 'Tipo de Movimiento',
    accessor: 'movementType',
    customCell: ({ row }) => (
      <div className="min-w-[180px]">
        <span className="font-medium capitalize text-black dark:text-white">
          {row.original.movementType?.toLowerCase() || '—'}
        </span>
      </div>
    ),
  },

  /**
   * 📊 Cantidad
   */
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => (
      <div className="min-w-[140px]">
        <span className="font-medium text-black dark:text-white">
          {formatCurrency(row.original.quantity || 0)}
        </span>
      </div>
    ),
  },

  /**
   * 💰 Costo Unitario
   */
  {
    Header: 'Costo Unitario',
    accessor: 'unitCost',
    showStatus: true,
    customCell: ({ row }) => (
      <div className="min-w-[160px]">
        <span className="font-bold text-primary">
          ${formatCurrency(row.original.unitCost || 0)}
        </span>
      </div>
    ),
  },

  /**
   * 📅 Fecha
   */
  {
    Header: 'Fecha',
    accessor: 'movementDate',
    customCell: ({ row }) => (
      <div className="min-w-[160px]">
        <span className="text-gray-600 dark:text-gray-400 whitespace-nowrap text-sm">
          {row.original.movementDate || '—'}
        </span>
      </div>
    ),
  },
];
